import {
  createFacetState,
} from './state';

import {
  prepareFacetOptions,
} from 'src/services/facetRanking';

function ensureFacet(
  state,
  facet,
) {
  if (
    !state.items[facet]
  ) {
    state.items[facet] =
      createFacetState();
  }

  return (
    state.items[facet]
  );
}

export function startRequest(
  state,
  {
    facet,
    sequence,
  },
) {
  const item =
    ensureFacet(
      state,
      facet,
    );

  item.sequence =
    sequence;

  item.loading =
    true;

  /*
   * Remove an old error while retrying.
   */
  item.error =
    false;
}

export function applyFacet(
  state,
  {
    facet,
    payload,
    rankingConfig = {},
  },
) {
  const item =
    ensureFacet(
      state,
      facet,
    );

  item.options =
    prepareFacetOptions(
      payload?.options ||
      [],
      rankingConfig,
    );

  item.selected =
    Object.freeze( [
      ...(
        payload?.selected ||
        []
      ),
    ] );

  item.loading =
    false;

  item.loadedOnce =
    true;

  item.error =
    false;
}

export function failFacet(
  state,
  facet,
) {
  const item =
    ensureFacet(
      state,
      facet,
    );

  item.loading =
    false;

  item.error =
    true;
}

export function requestRetry(
  state,
  facet,
) {
  const item =
    ensureFacet(
      state,
      facet,
    );

  item.retryToken += 1;
}

export function resetFacet(
  state,
  facet,
) {
  const current =
    ensureFacet(
      state,
      facet,
    );

  /*
   * Incrementing sequence invalidates any in-flight request
   * which started before this reset.
   */
  const nextSequence =
    current.sequence + 1;

  state.items[facet] = {
    ...createFacetState(),

    sequence:
    nextSequence,

    /*
     * Preserve retry token so reset itself doesn't look like
     * another retry click.
     */
    retryToken:
    current.retryToken,
  };
}

export function resetAll(
  state,
) {
  Object.keys(
    state.items,
  ).forEach(
    ( facet ) => {
      const current =
        state.items[facet];

      state.items[facet] = {
        ...createFacetState(),

        /*
         * Invalidates old batch responses.
         */
        sequence:
          current.sequence + 1,

        retryToken:
        current.retryToken,
      };
    },
  );
}
